if (!customElements.get('speakon-home-apps')) {
  customElements.define('speakon-home-apps', class extends HTMLElement {
    connectedCallback() {
      this.show();
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.played || this.dataset.animate !== 'true' || reduced.matches || !window.IntersectionObserver) return;
      this.events = new AbortController();
      this.classList.add('is-pending');
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.played = true;
        this.observer.disconnect();
        // Same one-time reveal lifecycle as the homepage statement; only opacity and transform animate.
        this.animations = [...this.querySelectorAll('[data-app-reveal]')].map((element, index) => element.animate([
          { opacity: 0, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 450, delay: index < 2 ? index * 60 : 120 + (index - 2) * 30, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'both' }));
        Promise.allSettled(this.animations.map(animation => animation.finished)).then(() => this.show());
      }, { rootMargin: '0px 0px -32px 0px' });
      this.observer.observe(this.querySelector('.speakon-apps__intro'));
      reduced.addEventListener('change', () => {
        if (reduced.matches) { this.played = true; this.show(); }
      }, { signal: this.events.signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.played) this.show();
      }, { signal: this.events.signal });
    }
    show() {
      this.classList.remove('is-pending');
      this.observer?.disconnect();
      this.events?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
    }
    disconnectedCallback() { this.show(); }
  });
}
